const seedThemeLight = {
  palette: {
    type: 'light',
  },
};

export default seedThemeLight;
